import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useStrategy } from '../../hooks/useStrategy';
import { useNullAssociationState } from '../../hooks/useNullAssociationState';
import getIn from 'transmute/getIn';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorIncludeObjectsWithNoAssociatedObjectsInput = props => {
  const {
    logicGroup,
    conditionPath
  } = props;
  const {
    getFilterFamilyObjectName
  } = useStrategy();
  const {
    showNullAssociationCheckbox,
    onCheckboxChange
  } = useNullAssociationState(logicGroup, conditionPath);
  if (!showNullAssociationCheckbox) {
    return null;
  }
  const associatedObjectName = getFilterFamilyObjectName(logicGroup.filterFamily, true);
  return /*#__PURE__*/_jsxs(Checkbox, {
    checked: Boolean(getIn(['includeObjectsWithNoAssociatedObjects'], logicGroup)),
    marginBlockStart: "300",
    onChange: onCheckboxChange,
    size: "small",
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "customerDataFiltersUI.customerDataFilters.FilterOperatorInput.includeObjectsWithNoAssociatedObjects",
      options: {
        associatedObjectName
      }
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "100",
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsx(UITooltip, {
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.customerDataFilters.FilterOperatorInput.includeObjectsWithNoAssociatedObjectsTooltipHeading"
        }),
        placement: "left",
        title: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerDataFiltersUI.customerDataFilters.FilterOperatorInput.includeObjectsWithNoAssociatedObjectsTooltipBody1",
              options: {
                associatedObjectName
              }
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerDataFiltersUI.customerDataFilters.FilterOperatorInput.includeObjectsWithNoAssociatedObjectsTooltipBody2"
            })
          }), /*#__PURE__*/_jsx(Text, {
            marginBlockEnd: "0",
            as: "p",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerDataFiltersUI.customerDataFilters.FilterOperatorInput.includeObjectsWithNoAssociatedObjectsTooltipBody3"
            })
          })]
        }),
        use: "longform",
        children: /*#__PURE__*/_jsx(UILink, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.customerDataFilters.FilterOperatorInput.includeObjectsWithNoAssociatedObjectsTooltipButtonLabel"
          })
        })
      })
    })]
  });
};
export default EditorIncludeObjectsWithNoAssociatedObjectsInput;